import { render, staticRenderFns } from "./dailyluck.vue?vue&type=template&id=6a69a155&scoped=true"
import script from "./dailyluck.vue?vue&type=script&lang=js"
export * from "./dailyluck.vue?vue&type=script&lang=js"
import style0 from "./dailyluck.vue?vue&type=style&index=0&id=6a69a155&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a69a155",
  null
  
)

export default component.exports